/**
 * Newsletter forms — progressive enhancement only (rebuilt 2026-09-25).
 * Footer/popup signup forms are native Shopify `customer` forms and are
 * submitted with a normal POST (no AJAX interception), so they work even
 * when JavaScript fails (e.g. Instagram's in-app browser) and Shopify's
 * spam challenge can run. This file only remembers a signup so the popup
 * doesn't reopen afterwards.
 */
(function () {
  'use strict';
  try {
    var forms = document.querySelectorAll('form[data-newsletter-source]');
    for (var i = 0; i < forms.length; i++) {
      forms[i].addEventListener('submit', function () {
        try {
          document.cookie = 'lena_di_newsletter_popup_suppressed=1; max-age=604800; path=/; SameSite=Lax';
        } catch (e) {}
      });
    }
  } catch (e) {}
})();
